import Tooltip from "~/components/Tooltip";
import { getInvoiceStatusDisplayNameById } from "~/modules/billing/api/invoiceStatus/invoiceStatusId.ts";
import type { InvoiceStatus } from "~/modules/billing/api/invoiceStatus/invoiceStatusIdTypes.ts";
import type { InvoiceStatusId } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import type {
	InvoiceProgressSegmentState,
} from "~/modules/billing/components/InvoiceDetailsView/components/InvoiceStatusProgressBar/invoiceStatusProgressBarTypes.ts";

import { invoiceStatusProgressSegmentVariants } from "./invoiceStatusProgressSegmentVariants.ts";

type Props = {
	isFirst: boolean;
	isLast: boolean;
	isSelfBilledInvoice: boolean;
	onClick?: (statusId: InvoiceStatusId) => void;
	status: InvoiceStatus;
	theme: InvoiceProgressSegmentState;
	tooltip?: string;
};

export default function InvoiceStatusProgressSegment({
	isFirst,
	isLast,
	isSelfBilledInvoice,
	onClick,
	status,
	theme,
	tooltip,
}: Props) {
	const label = getInvoiceStatusDisplayNameById(status.id, isSelfBilledInvoice);
	const isDisabled = theme === "disabled" || theme === "status-unavailable" || theme === "reversed" || theme === "active" || theme === "paid" || !onClick;
	const { container, caretFill, caretStroke } =
		invoiceStatusProgressSegmentVariants({ theme, isFirst, isLast});


	const content = (
		<button
			type="button"
			onClick={!isDisabled && onClick ? () => onClick(status.id) : undefined}
			className={container()}
			style={{
				paddingLeft: isFirst ? 12 : 20,
				paddingRight: isLast ? 12 : 20,
			}}
			disabled={isDisabled}
		>
			{label}

			{!isLast && (
				<svg
					className="absolute -top-px right-0 z-10 h-[calc(100%+2px)] translate-x-[calc(100%-1px)]"
					viewBox="0 0 14 40"
					preserveAspectRatio="none"
					width={14}
				>
					<polygon
						points="0,0 12,20 0,40"
						className={caretFill()}
					/>
					<polyline
						points="0,0 12,20 0,40"
						fill="none"
						className={caretStroke()}

					/>
				</svg>
			)}
		</button>
	);


	return tooltip ? (
		<Tooltip text={tooltip}>{content}</Tooltip>
	) : (
		content
	);
}